import aleksandrImg from '../img/team/aleksandr-k.jpg';
import oksanaImg from '../img/team/oksana.jpg';
import alekseiImg from '../img/team/aleksei.jpg';
import dmytroImg from '../img/team/dmytro.jpg';
import yuliaImg from '../img/team/yulia.jpg';
import antonImg from '../img/team/anton.jpg';
import maximImg from '../img/team/maksim.jpg';
import evgeniyImg from '../img/team/evgeniy.jpg';
import yelyzavetaImg from '../img/team/yelyzaveta.jpg';
import artemImg from '../img/team/artem.jpg';
import yuriiImg from '../img/team/yurii.jpg';

export const teamInfo = [
  {
    name: 'Aleksandr Kadulin',
    img: `${aleksandrImg}`,
    socialLink: 'https://github.com/NilKad',
    teamRole: 'Team Lead',
  },
  {
    name: 'Oksana Kuzich',
    img: `${oksanaImg}`,
    socialLink: 'https://github.com/OksanaKuzich',
    teamRole: 'Scrum Master',
  },
  {
    name: 'Aleksei Baliuk',
    img: `${alekseiImg}`,
    socialLink: 'https://github.com/AlekseiBaliukveloper',
    teamRole: 'Developer',
  },
  {
    name: 'Dmytro Kobeza',
    img: `${dmytroImg}`,
    socialLink: 'https://github.com/kobeza1',
    teamRole: 'Developer',
  },
  {
    name: 'Yulia Sukhonenko',
    img: `${yuliaImg}`,
    socialLink: 'https://github.com/Yulia0907',
    teamRole: 'Developer',
  },
  {
    name: 'Anton Ostapienko',
    img: `${antonImg}`,
    socialLink: 'https://github.com/AntonyUser',
    teamRole: 'Developer',
  },
  {
    name: 'Maksim Siomak',
    img: `${maximImg}`,
    socialLink: 'https://github.com/Pleomax07',
    teamRole: 'Developer',
  },
  {
    name: 'Evgeniy Zyuskin',
    img: `${evgeniyImg}`,
    socialLink: 'https://github.com/Yevhenns',
    teamRole: 'Developer',
  },
  {
    name: 'Yelyzaveta Demchenko',
    img: `${yelyzavetaImg}`,
    socialLink: 'https://github.com/yelyzaveta05',
    teamRole: 'Developer',
  },
  {
    name: 'Artem Borzov',
    img: `${artemImg}`,
    socialLink: 'https://github.com/Artem-Borzov',
    teamRole: 'Developer',
  },
  {
    name: 'Yurii Shulga',
    img: `${yuriiImg}`,
    socialLink: 'https://github.com/Yurkes2020',
    teamRole: 'Developer',
  },
];
